
import React, { Component } from "react";
import { Row, Col, Form, Select, Input, Tabs } from "antd";

import TabApprover from "./include/SecApprover";
import TabApproverTable from "./include/SecApproverTable";
import TabHistory from "./include/SecHistory";

const { TabPane } = Tabs;

class SecProfileInformation extends Component {
  state = {
    detailForm: null,
    preLoadOnsubmit: false,
    loadingFullpage: true,
  };

  render() {
    const {
      propFormInput,
      isViewOnly,
      rawDataApprover,
      rawDataHistory,
      dropdownListApprover,
      status,
    } = this.props;
    const {} = this.state;

    return (
      <div className="box-color-white">
        <Row gutter={16} type="flex" justify="left" align="top">
          <Col xs={24} md={24} className="pt-2">
            <Tabs
              type="card"
              rawDataApprover={{ rawDataApprover }}
              rawDataHistory={{ rawDataHistory }}
              propFormInput={{ propFormInput }}
              isViewOnly={{ isViewOnly }}
              status={{status}}
              defaultActiveKey="4"
            >
               <TabPane tab="ผู้อนุมัติ" key="1" className="py-4 px-0">
                  { isViewOnly == false ?
                     <TabApprover
                        rawData={rawDataApprover}
                        propFormInput={propFormInput}
                        isViewOnly={isViewOnly}
                        dropdownListApprover={dropdownListApprover}
                        status={status}
                        forceRender
                     />
                  :
                     <TabApproverTable
                        rawData={rawDataApprover}
                        propFormInput={propFormInput}
                        isViewOnly={isViewOnly}
                        dropdownListApprover={dropdownListApprover}
                        status={status}
                        forceRender
                     />
                  }
               </TabPane>
              {status != "create" && (
                <TabPane
                  tab="ประวัติการดำเนินการ"
                  key="2"
                  className="py-4 px-0"
                >
                  <TabHistory
                    rawData={rawDataHistory}
                    propFormInput={propFormInput}
                    isViewOnly={isViewOnly}
                    forceRender
                  />
                </TabPane>
              )}
            </Tabs>
          </Col>
        </Row>
      </div>
    );
  }
}

export default SecProfileInformation;
